<template>
  <div>
    <md-card>
      <md-card-header class="md-card-header-text md-card-header-green">
        <div class="card-text">
          <h4 class="title text-lg">
            {{ $t("progress_report.configuration") }}
          </h4>
        </div>
      </md-card-header>
      <md-card-content>
        <div class="md-layout pb-10">
          <div class="md-layout-item md-size-100 font-normal">
            <p>{{ $t("progress_report.setup_sending_mode") }}</p>
          </div>
          <div class="md-layout-item md-size-100">
            <md-radio
              :disabled="true"
              v-model="form.type_sending_model"
              value="No-review"
              >{{ $t("progress_report.send_without_reviewing") }}
            </md-radio>
            <md-radio
              :disabled="true"
              v-model="form.type_sending_model"
              value="Review"
              >{{ $t("progress_report.must_review_before_sending") }}
            </md-radio>
          </div>
          <div class="md-layout-item md-size-100 font-normal">
            <p>{{ $t("progress_report.set_up_authorized_roles") }}</p>
          </div>
          <!--          no review-->
          <div
            class="md-layout-item md-size-33"
            v-if="form.type_sending_model === 'No-review'"
          >
            <label class="subject-label">{{
              $t("progress_report.inputter")
            }}</label>
            <checkbox-multi-select
              :options="selectInputterNoReview.options"
              :trackBy="selectInputterNoReview.trackBy"
              :displayField="selectInputterNoReview.displayField"
              v-model="form.inputter_no_review_ids"
              :style="{ marginTop: '-6px' }"
            >
            </checkbox-multi-select>
          </div>
          <!--          review-->
          <div
            class="md-layout-item md-size-33"
            v-if="form.type_sending_model === 'Review'"
          >
            <label class="subject-label">{{
              $t("progress_report.inputter")
            }}</label>
            <checkbox-multi-select
              :options="selectInputter.options"
              :trackBy="selectInputter.trackBy"
              :displayField="selectInputter.displayField"
              :is-disabled="true"
              v-model="form.inputer_ids"
              :style="{ marginTop: '-6px' }"
            >
            </checkbox-multi-select>
          </div>
          <div
            class="md-layout-item md-size-33"
            v-if="form.type_sending_model === 'Review'"
          >
            <label class="subject-label">{{
              $t("progress_report.reviewer")
            }}</label>
            <checkbox-multi-select
              :options="selectReviewer.options"
              :trackBy="selectReviewer.trackBy"
              :displayField="selectReviewer.displayField"
              :is-disabled="true"
              v-model="form.reviewer_ids"
              :style="{ marginTop: '-6px' }"
            >
            </checkbox-multi-select>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <!--    form update-->
    <!--    <div class="flex justify-center">-->
    <!--      <md-button-->
    <!--        class="md-success"-->
    <!--        @click.prevent="updateConfiguration(false)"-->
    <!--        >{{ $t("common.update") }}</md-button-->
    <!--      >-->
    <!--    </div>-->
    <!--    form update-->
  </div>
</template>
<script>
import CheckboxMultiSelect from "@/components/Base/CheckboxMultiSelect";
import { service_names } from "@/constants/Services";
import { getId, Message } from "@/helpers/utils";

const sendingMode = { review: "Review", noReview: "No-review" };
const authorized = { inputter: "Inputter", review: "Review" };
export default {
  components: { CheckboxMultiSelect },
  data() {
    return {
      getId,
      sendingMode: sendingMode,
      authorized: authorized,
      form: {
        type_sending_model: null,
        inputter_no_review_ids: [],
        inputer_ids: [],
        reviewer_ids: []
      },
      defaultOptions: [],
      selectInputterNoReview: {
        name: "inputter",
        value: [],
        type: "checkbox-multi-select",
        options: [],
        trackBy: "id",
        displayField: "name"
      },
      selectInputter: {
        name: "inputter",
        value: [],
        type: "checkbox-multi-select",
        options: [],
        trackBy: "id",
        displayField: "name"
      },
      selectReviewer: {
        name: "reviewer",
        value: [],
        type: "checkbox-multi-select",
        options: [],
        trackBy: "id",
        displayField: "name"
      }
    };
  },
  created() {
    this.initData();
  },
  watch: {
    // "form.inputer_ids": function(newVal) {
    //   this.selectReviewer.options = this.filterListOption(newVal);
    // },
    // "form.reviewer_ids": function(newVal) {
    //   this.selectInputter.options = this.filterListOption(newVal);
    // },
    "form.type_sending_model": function() {
      this.$emit("switchSendingMode", this.form.type_sending_model);
    }
  },
  methods: {
    async initData() {
      await this.fetchAuthorizeRoles();
      await this.setRoleSelected();
      this.updateConfiguration(true);
    },
    async setRoleSelected() {
      const path = `${service_names.user}/progress-setting/config`;
      const { data } = await this.$axios.get(path);
      if (!data) return;

      this.form.type_sending_model = data.type_sending_model;
      if (data.type_sending_model === sendingMode.noReview) {
        this.form.inputter_no_review_ids = data.authorized_role_id;
        return;
      }

      this.form.inputer_ids = data.authorized.find(
        el => el.name === this.authorized.inputter
      ).authorized_role_id;
      this.form.reviewer_ids = data.authorized.find(
        el => el.name === this.authorized.review
      ).authorized_role_id;
    },
    updateConfiguration(isInitSetting) {
      const form = this.setFormUpdate();
      if (!form) return;
      this.$emit("updateConfiguration", {
        form,
        isInitSetting
      });
    },
    setFormUpdate() {
      let form = {};
      if (this.form.type_sending_model === this.sendingMode.review) {
        if (!this.form.inputer_ids.length || !this.form.reviewer_ids.length) {
          Message.error(this.$t("progress_report.select_authorized_roles"));
          return;
        }
        form.type_sending_model = this.sendingMode.review;
        form.authorized = [
          {
            name: this.authorized.inputter,
            authorized_role_id: this.form.inputer_ids
          },
          {
            name: this.authorized.review,
            authorized_role_id: this.form.reviewer_ids
          }
        ];
      } else {
        if (!this.form.inputter_no_review_ids.length) {
          Message.error(this.$t("progress_report.select_authorized_roles"));
          return;
        }
        form.type_sending_model = this.sendingMode.noReview;
        form.authorized = this.authorized.inputter;
        form.authorized_role_id = this.form.inputter_no_review_ids;
      }
      form.limit = 50;
      return form;
    },
    filterListOption(selectedIds) {
      return this.defaultOptions.filter(val => !selectedIds.includes(val.id));
    },
    async fetchAuthorizeRoles() {
      await this.$axios
        .get(`${service_names.user}/progress-setting/roles`)
        .then(response => {
          const data = response.data;
          this.defaultOptions = data;
          this.selectInputter.options = data;
          this.selectReviewer.options = data;
          this.selectInputterNoReview.options = data;
        });
    }
  }
};
</script>
<style lang="scss" scoped></style>
